import { useEffect, useRef } from 'react';
import {
  NavigationStore,
  useNavigationStore,
} from '../navigation/useNavigationStore';
import { useLocation } from 'react-router-dom';

type UsePageHeaderParams = Pick<
  NavigationStore,
  'title' | 'breadcrumb' | 'icon'
>;

export const usePageHeader = ({
  title,
  breadcrumb,
  icon,
}: UsePageHeaderParams) => {
  const { pathname } = useLocation();
  const { setPageHeader } = useNavigationStore();

  const navigationStorePropsRef = useRef<UsePageHeaderParams>({
    title,
    breadcrumb,
    icon,
  });

  navigationStorePropsRef.current = {
    title,
    breadcrumb,
    icon,
  };

  useEffect(() => {
    setPageHeader(navigationStorePropsRef.current);
  }, [pathname]);

  useEffect(() => {
    return () => {
      setPageHeader({
        title: undefined,
        breadcrumb: undefined,
        icon: undefined,
      });
    };
  }, []);
};
